export default __webpack_public_path__ + "static/media/add-cliente-venta.7f43f89a.svg";